import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Heart, ChevronDown, ChevronUp, Minus, Plus, ShoppingBag, Truck, RotateCcw, Ruler } from 'lucide-react';
import Header from './components/Header17';
import Footer from './components/Footer17';

const ProductDetail17 = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [selectedSize, setSelectedSize] = useState('M');
    const [quantity, setQuantity] = useState(1);
    const [selectedImage, setSelectedImage] = useState(0);
    const [wishlisted, setWishlisted] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);
    const [hoveredRelated, setHoveredRelated] = useState(null);

    const allProducts = [
        {
            id: 1, name: 'Chanderi Silk Saree', price: 7999, originalPrice: 9999, category: 'Curated Sarees',
            description: 'A museum-worthy Chanderi silk saree featuring centuries-old weaving techniques from Madhya Pradesh. Each thread is a testament to the quiet perseverance of Indian textile artistry.',
            images: [
                'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 2, name: 'Banarasi Art Weave', price: 12499, category: 'Curated Sarees',
            description: 'Woven by master artisans of Varanasi, this Banarasi features intricate zari work that transforms light into liquid gold. A gallery piece for the discerning collector.',
            images: [
                'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 3, name: 'Block Print Kurta', price: 4999, category: 'Art Kurtas',
            description: 'Hand-carved wooden blocks meet natural dyes in this artisanal kurta. Each print is slightly unique — an artwork signed by nature itself.',
            images: [
                'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 4, name: 'Tussar Silk Dupatta', price: 3499, category: 'Gallery Pieces',
            description: 'Wild tussar silk with its natural golden sheen, minimally adorned to let the fabric speak. A study in the beauty of restraint.',
            images: [
                'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 5, name: 'Ikat Palazzo Set', price: 6999, originalPrice: 8499, category: 'Designer Edits',
            description: 'Traditional Pochampally Ikat reimagined as a contemporary palazzo set. Where heritage geometry meets modern silhouettes.',
            images: [
                'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
        {
            id: 6, name: 'Kalamkari Anarkali', price: 8499, category: 'Gallery Pieces',
            description: 'Hand-painted Kalamkari motifs adorn this flowing anarkali, each stroke a meditation in vegetable dyes and ancient temple art.',
            images: [
                'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800',
                'https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=800',
            ],
        },
    ];

    const sizes = ['XS', 'S', 'M', 'L', 'XL'];
    const product = allProducts.find(p => p.id === parseInt(id)) || allProducts[0];
    const relatedProducts = allProducts.filter(p => p.id !== product.id).slice(0, 4);

    const accordions = [
        { title: 'Artisan Details', content: 'Handcrafted by master artisans using techniques passed down through generations. Each piece takes 15-30 days to create, ensuring museum-quality craftsmanship.' },
        { title: 'Fabric & Care', content: 'Pure handloom fabric. Dry clean recommended. Store in a cool, dry place away from direct sunlight. Iron on low heat with a pressing cloth.' },
        { title: 'Shipping & Returns', content: 'Complimentary shipping on orders above \u20B95,000. Ships within 3-5 business days. 7-day return policy for unworn items with original tags.' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Source+Serif+4:wght@400;600;700&family=Inter:wght@300;400;500&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Inter', -apple-system, sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-[88px] pb-16">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
                        {/* Breadcrumb */}
                        <div className="py-6" style={{ borderBottom: '1px solid #E4E4E7' }}>
                            <div className="flex items-center gap-2 text-sm" style={{ fontWeight: 300 }}>
                                <span onClick={() => navigate('/template17')} className="cursor-pointer" style={{ color: '#71717A' }}>Home</span>
                                <span style={{ color: '#D4D4D8' }}>/</span>
                                <span onClick={() => navigate('/template17/shop')} className="cursor-pointer" style={{ color: '#71717A' }}>Gallery</span>
                                <span style={{ color: '#D4D4D8' }}>/</span>
                                <span style={{ color: '#18181B' }}>{product.name}</span>
                            </div>
                        </div>

                        {/* Product Detail */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 mt-8 lg:mt-12">
                            {/* Images */}
                            <div>
                                <div className="aspect-[3/4] overflow-hidden mb-4" style={{ backgroundColor: '#FAFAFA' }}>
                                    <img
                                        src={product.images[selectedImage]}
                                        alt={product.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="grid grid-cols-4 gap-3">
                                    {product.images.map((img, i) => (
                                        <button
                                            key={i}
                                            onClick={() => setSelectedImage(i)}
                                            className="aspect-square overflow-hidden"
                                            style={{
                                                border: selectedImage === i ? '2px solid #18181B' : '1px solid #E4E4E7',
                                                padding: selectedImage === i ? '1px' : '0',
                                                backgroundColor: '#FAFAFA',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <img src={img} alt="" className="w-full h-full object-cover" />
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Info */}
                            <div className="lg:pt-4">
                                <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#71717A', fontWeight: 300 }}>
                                    {product.category}
                                </p>
                                <h1
                                    className="text-2xl lg:text-3xl font-normal mb-4"
                                    style={{ fontFamily: "'Source Serif 4', Georgia, serif", color: '#18181B' }}
                                >
                                    {product.name}
                                </h1>
                                <div className="flex items-center gap-3 mb-6">
                                    <span className="text-xl" style={{ color: '#18181B', fontWeight: 400 }}>
                                        {`\u20B9${product.price.toLocaleString('en-IN')}`}
                                    </span>
                                    {product.originalPrice && (
                                        <span className="text-base line-through" style={{ color: '#A1A1AA' }}>
                                            {`\u20B9${product.originalPrice.toLocaleString('en-IN')}`}
                                        </span>
                                    )}
                                </div>

                                <div className="w-full h-px mb-6" style={{ backgroundColor: '#E4E4E7' }} />

                                <p className="text-sm leading-relaxed mb-8" style={{ color: '#71717A', fontWeight: 300 }}>
                                    {product.description}
                                </p>

                                {/* Size */}
                                <div className="mb-6">
                                    <div className="flex items-center justify-between mb-3">
                                        <span className="text-sm" style={{ color: '#18181B', fontWeight: 400 }}>Size</span>
                                        <button className="text-xs underline underline-offset-2" style={{ color: '#71717A', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 300 }}>
                                            <Ruler size={14} className="inline mr-1" /> Size Guide
                                        </button>
                                    </div>
                                    <div className="flex gap-2">
                                        {sizes.map((size) => (
                                            <button
                                                key={size}
                                                onClick={() => setSelectedSize(size)}
                                                style={{
                                                    width: '44px',
                                                    height: '44px',
                                                    border: selectedSize === size ? '2px solid #18181B' : '1px solid #E4E4E7',
                                                    backgroundColor: selectedSize === size ? '#18181B' : 'transparent',
                                                    color: selectedSize === size ? '#FFFFFF' : '#18181B',
                                                    fontFamily: "'Inter', sans-serif",
                                                    fontSize: '13px',
                                                    fontWeight: 400,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {size}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Quantity */}
                                <div className="mb-8">
                                    <span className="text-sm mb-3 block" style={{ color: '#18181B', fontWeight: 400 }}>Quantity</span>
                                    <div className="inline-flex items-center" style={{ border: '1px solid #E4E4E7' }}>
                                        <button
                                            onClick={() => setQuantity(q => Math.max(1, q - 1))}
                                            style={{ width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer' }}
                                        >
                                            <Minus size={16} color="#18181B" />
                                        </button>
                                        <span style={{ width: '48px', textAlign: 'center', fontSize: '14px', fontWeight: 400, color: '#18181B' }}>{quantity}</span>
                                        <button
                                            onClick={() => setQuantity(q => q + 1)}
                                            style={{ width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer' }}
                                        >
                                            <Plus size={16} color="#18181B" />
                                        </button>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="flex gap-3 mb-8">
                                    <button
                                        onClick={() => navigate('/template17/cart')}
                                        className="flex-1 inline-flex items-center justify-center gap-2 py-4 text-[13px] tracking-[0.15em] uppercase transition-all duration-300"
                                        style={{ backgroundColor: '#18181B', color: '#FFFFFF', border: 'none', fontFamily: "'Inter', sans-serif", fontWeight: 500, cursor: 'pointer' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#27272A'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#18181B'; }}
                                    >
                                        <ShoppingBag size={16} /> Add to Bag
                                    </button>
                                    <button
                                        onClick={() => setWishlisted(!wishlisted)}
                                        style={{
                                            width: '52px',
                                            height: '52px',
                                            border: '1px solid #E4E4E7',
                                            backgroundColor: 'transparent',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        <Heart size={20} style={{ color: wishlisted ? '#18181B' : '#71717A', fill: wishlisted ? '#18181B' : 'none' }} />
                                    </button>
                                </div>

                                {/* Features */}
                                <div className="flex gap-6 mb-8 py-6" style={{ borderTop: '1px solid #E4E4E7', borderBottom: '1px solid #E4E4E7' }}>
                                    <div className="flex items-center gap-2">
                                        <Truck size={16} style={{ color: '#71717A' }} />
                                        <span className="text-xs" style={{ color: '#71717A', fontWeight: 300 }}>Free Shipping</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <RotateCcw size={16} style={{ color: '#71717A' }} />
                                        <span className="text-xs" style={{ color: '#71717A', fontWeight: 300 }}>7 Day Returns</span>
                                    </div>
                                </div>

                                {/* Accordions */}
                                {accordions.map((acc, i) => (
                                    <div key={i} style={{ borderBottom: '1px solid #E4E4E7' }}>
                                        <button
                                            onClick={() => setOpenAccordion(openAccordion === i ? null : i)}
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '16px 0',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <span style={{ fontFamily: "'Source Serif 4', Georgia, serif", fontSize: '15px', color: '#18181B', fontWeight: 400 }}>
                                                {acc.title}
                                            </span>
                                            {openAccordion === i ? <ChevronUp size={16} color="#71717A" /> : <ChevronDown size={16} color="#71717A" />}
                                        </button>
                                        {openAccordion === i && (
                                            <p style={{ fontSize: '14px', color: '#71717A', fontWeight: 300, lineHeight: 1.7, paddingBottom: '16px' }}>
                                                {acc.content}
                                            </p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Related */}
                        <div className="mt-20 lg:mt-32">
                            <h2
                                className="text-2xl lg:text-3xl font-normal mb-10 text-center"
                                style={{ fontFamily: "'Source Serif 4', Georgia, serif", color: '#18181B' }}
                            >
                                From the Gallery
                            </h2>
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
                                {relatedProducts.map((rp) => (
                                    <div
                                        key={rp.id}
                                        onClick={() => navigate(`/template17/product/${rp.id}`)}
                                        onMouseEnter={() => setHoveredRelated(rp.id)}
                                        onMouseLeave={() => setHoveredRelated(null)}
                                        className="cursor-pointer group"
                                    >
                                        <div className="aspect-[3/4] overflow-hidden mb-3" style={{ backgroundColor: '#FAFAFA' }}>
                                            <img src={rp.images[0]} alt={rp.name} className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500" />
                                        </div>
                                        <h3
                                            className="text-sm font-normal mb-1"
                                            style={{
                                                fontFamily: "'Source Serif 4', Georgia, serif",
                                                color: '#18181B',
                                                textDecoration: hoveredRelated === rp.id ? 'underline' : 'none',
                                                textUnderlineOffset: '3px',
                                            }}
                                        >
                                            {rp.name}
                                        </h3>
                                        <p className="text-sm" style={{ color: '#18181B', fontWeight: 400 }}>{`\u20B9${rp.price.toLocaleString('en-IN')}`}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default ProductDetail17;
